import { computed, ref } from 'vue'
// types
import type { ComputedRef, Ref } from 'vue'
import type { FaqGroup, SectionFaqMultipleProps } from '@ts-sections/section-faq-multiple/interfaces'

interface SectionFaqMultipleHookOptions {
  section: () => SectionFaqMultipleProps
}

interface SectionFaqMultipleHookReturn {
  refGroups: ComputedRef<FaqGroup[]>
  refActiveIndex: Ref<number>
  refCategories: ComputedRef<string[]>
  handleSelectCategory: (index: number) => void
}

export const useSectionFaqMultiple = ({ section }: SectionFaqMultipleHookOptions): SectionFaqMultipleHookReturn => {
  const refGroups = computed<FaqGroup[]>(() => section().faq ?? [])
  const refCategories = computed<string[]>(() => refGroups.value.map(group => group.title))
  const refActiveIndex = ref<number>(0)

  const handleSelectCategory = (index: number): void => {
    refActiveIndex.value = index
  }

  return {
    refGroups,
    refCategories,
    refActiveIndex,
    handleSelectCategory,
  }
}